<template>
  <div>
    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col>
        <b-button
          variant='outline-primary'
          @click='() => actions.handleAddFaqElementToList(flatPage.id, item.id)'
        >
          Dodaj element do listy
        </b-button>
      </b-col>          
    </b-row>

    <b-row class='mb-2'>
      <b-col>
        <label>Kolor czcionki pytania</label>
        <b-form-input
          type='color'
          v-model='item.questionFontColor'
        />
      </b-col>
      <b-col>
        <label>Kolor tła pytania</label>
        <b-form-input
          type='color'
          v-model='item.questionBackgroundColor'
        />
      </b-col>
      <b-col>
        <label>Wielkość czcionki pytania</label>
        <b-form-input
          type='number'
          v-model='item.questionFontSize'
        />
      </b-col>
      <b-col>
        <label>Kolor czcionki odpowiedzi</label>
        <b-form-input
          type='color'
          v-model='item.answerFontColor'
        />
      </b-col>
      <b-col>
        <label>Kolor tła odpowiedzi</label>
        <b-form-input
          type='color'
          v-model='item.answerBackgroundColor'
        />
      </b-col>
      <b-col>
        <label>Wielkość czcionki odpowiedzi</label>
        <b-form-input
          type='number'
          v-model='item.answerFontSize'
        />
      </b-col>
    </b-row>
    <b-row class='mb-2'>
      <b-col cols="2">
        <label>Margines górny</label>
        <b-form-input
          type='number'
          v-model='item.faqMarginTop'
        />
      </b-col> 
      <b-col cols="2">
        <label>Margines dolny</label>
        <b-form-input
          type='number'
          v-model='item.faqMarginBottom'
        />
      </b-col> 
    </b-row>
    <b-row class='mb-2'>
      <b-col style='border-top: 2px solid silver;' class="pb-3">
        <b-row v-for='(faqItem, i) in item.value.items' :key='i' class='mt-3'>
          <b-col>
            <b-row>
              <b-col>
                <b-button size='sm' class='float-right' variant="danger" @click.prevent='() => handleClickRemoveFaqItem(faqItem)'><b-icon-trash /></b-button>
              </b-col>
            </b-row>
          
            <b-row>
              <b-col cols="1" style='border-bottom: 2px solid silver;' class="pb-3">
                #{{ faqItem.id }}
              </b-col>
              <b-col cols="11" style='border-bottom: 2px solid silver;' class="pb-3">
                <b-row class="mb-2">
                  <b-col v-for='(locale, i) in locales' :key='i'>
                    <label>Pytanie {{locale}}</label>
                    <b-form-input
                      v-model="faqItem.q[locale]"
                    />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col v-for='(locale, i) in locales' :key='i'>
                    <label>Odpowiedź {{locale}}</label>
                    <b-form-textarea :id="`flatpage${flatPage.id}_item${item.id}_locale${i}`"
                      rows='3'
                      max-rows='6'
                      placeholder='wpisz tekst...'
                      v-model='faqItem.a[locale]'
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {
    BIconTrash,
  } from 'bootstrap-vue'

  import { LOCALES } from '@/utils';

  import {
    handleItemTextValueChanged,
    handleItemTextStyleChanged,
    handleAddFaqElementToList,
    handleRemoveItemFromArray,
  } from '@/store/utils.js'
  
  export default {
    props: ['flatPage', 'item'],
    components: {
      BIconTrash,
    },    
    computed: {
      color() {
        try {
          return this.item.style.color
        } catch (e) {
          return '#000000'
        }
      },
      size() {
        try {
          return this.item.style.size || 12
        } catch (e) {
          return 12
        }
      },
      marginTop() {
        try {
          return this.item.style.marginTop || 10
        } catch (e) {
          return 10
        }
      },
      marginBottom() {
        try {
          return this.item.style.marginBottom || 10
        } catch (e) {
          return 10
        }
      },
    },
    data() {
      return {
        actions: {
          handleItemTextValueChanged,
          handleItemTextStyleChanged,
          handleAddFaqElementToList,
          handleRemoveItemFromArray,
        },
        locales: LOCALES,
        modelFontWeight: this.item.style && this.item.style.fontWeight ? this.item.style.fontWeight : 'normal',
        modelFontStyle: this.item.style && this.item.style.fontStyle ? this.item.style.fontStyle : 'normal',
      }
    },
    methods: {
      handleClickRemoveFaqItem(faqItem) {
        if (confirm(`Usunąć pytanie [${faqItem.q.pl}]?`) === true) {
          this.actions.handleRemoveItemFromArray(this.item.value, 'items', faqItem)
        }
      }
    },
  }
</script>
